import { render, staticRenderFns } from "./couponAgentD.vue?vue&type=template&id=694b5e12&scoped=true&"
import script from "./couponAgentD.vue?vue&type=script&lang=ts&"
export * from "./couponAgentD.vue?vue&type=script&lang=ts&"
import style0 from "./couponAgentD.vue?vue&type=style&index=0&id=694b5e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694b5e12",
  null
  
)

export default component.exports